import { jsx as _jsx } from "react/jsx-runtime";
import HyperDX from '@hyperdx/browser';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { Spinner, makeLocationUrl, QUERY_KEY, CREDIT_PORTAL_URL, API_ERROR_MAP, APPLICATION_FINDER_URL, reportError, parseQuery, getRTKQueryErrorMessage, } from 'shared';
import { useLazyGetConsumerApplicationsV1CreditApplicationsTokenTokenValidateQuery } from 'consumer-applications-v1-api';
import { useLazyGetConsumerApplicationsV2PrequalificationsNewQuery } from 'consumer-applications-v2-api';
import { useSessionStorage } from 'hooks';
import { toastError } from 'utils';
import { selectors as creditPortalSelectors } from '../../reducer';
import { setPersonalInfo, setPractice, setCreditApplication, setPersonalInfoOTA, } from '../actions';
import { selectors } from '../reducer';
function PushApplication() {
    const { search } = useLocation();
    const dispatch = useDispatch();
    const creditApplication = useSelector(selectors.creditApplication);
    const practice = useSelector(selectors.practice);
    const personalInfo = useSelector(selectors.personalInfo);
    const submittedOtaToken = useSelector(creditPortalSelectors.submittedOtaToken);
    const { setValue: setIsOTA } = useSessionStorage('isOTA');
    const query = parseQuery(search);
    const token = query[QUERY_KEY.TOKEN];
    const history = useHistory();
    const [getCreditApplicationByTokenValidate, { isError, error }] = useLazyGetConsumerApplicationsV1CreditApplicationsTokenTokenValidateQuery();
    const [getConsumerApplicationsV2PrequalificationsNew] = useLazyGetConsumerApplicationsV2PrequalificationsNewQuery();
    const redirectToStoreWizard = async (creditApplication) => {
        const res = await getConsumerApplicationsV2PrequalificationsNew({
            locationId: practice?.locationId,
            termsLanguage: 'en',
        });
        setIsOTA('true');
        if (res.data) {
            const { proveOptOut } = res.data;
            if (!proveOptOut) {
                history.push({
                    pathname: '/credit-portal/prove/ota',
                    search: `?token=${token}&store=${practice.adsStoreNumber}&locationId=${practice.locationId}&ref=push-app`,
                    state: {
                        personalInfo: personalInfo,
                        practice: practice,
                        creditApplication: creditApplication,
                    },
                });
            }
            else {
                history.push({
                    pathname: makeLocationUrl(practice.locationId),
                    search: '?token=' + token + '&ref=push-app',
                    state: {
                        practice: practice,
                    },
                });
            }
        }
    };
    useEffect(() => {
        if (isError && 'status' in error) {
            const errorMessage = getRTKQueryErrorMessage(error);
            if (errorMessage === 'no_credit_application_found') {
                reportError('flashError', {
                    componentName: 'PushApplications',
                    funcName: 'getCreditApplicationByTokenValidate',
                    errType: 'token',
                    errURL: window.location.pathname,
                    errMsg: API_ERROR_MAP.no_credit_application_found_one_time,
                }, new Error(API_ERROR_MAP.no_credit_application_found_one_time));
                toastError(API_ERROR_MAP.no_credit_application_found_one_time);
                history.push(CREDIT_PORTAL_URL);
            }
        }
    }, [isError]);
    useEffect(() => {
        getCreditApplicationByTokenValidate({ token }).then((res) => {
            if ('data' in res) {
                dispatch(setCreditApplication(res.data?.creditApplication));
                dispatch(setPractice(res.data?.location));
                dispatch(setPersonalInfo(res.data?.applicant));
                dispatch(setPersonalInfoOTA(res.data?.applicant));
            }
        });
    }, []);
    useEffect(() => {
        if (creditApplication && creditApplication.applicationId && practice) {
            setPractice(practice);
            setPersonalInfo(personalInfo);
            HyperDX.setGlobalAttributes({
                locationId: practice.locationId.toString(),
                storeNumber: practice.adsStoreNumber.toString(),
                creditApplicationId: creditApplication?.applicationId.toString(),
                lastName: personalInfo.lastName,
                firstName: personalInfo.firstName,
                email: personalInfo.email,
                phone: personalInfo.primaryPhone,
                form: 'access-loan',
            });
            if (creditApplication.applicationStatus === 'created' &&
                submittedOtaToken !== token) {
                redirectToStoreWizard(creditApplication);
            }
            else {
                history.push(APPLICATION_FINDER_URL); // To  Do handle this
            }
        }
    }, [creditApplication, practice]);
    return _jsx(Spinner, { centerPage: true });
}
export default PushApplication;
